import Interest from '@/models/Interest'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    interestDetails: null,
  },

  mutations: {
    setInterestList(state, interests) {
      each(interests, (interest) => {
        const exist = find(state.list, { id: interest.id })
        if (!exist) {
          state.list.push(new Interest(interest))
        }
      })
    },

    clearInterestList(state) {
      state.list = []
    },

    setInterestListMeta(state, meta) {
      state.listMeta = meta
    },

    setInterestDetails(state, interest) {
      if (interest instanceof Interest) {
        state.interestDetails = interest
      } else {
        state.interestDetails = new Interest(interest)
      }
    },

    clearInterestDetails(state) {
      state.interestDetails = null
    },
  },

  actions: {
    async getInterests({ commit }, params) {
      const query = Interest.page(params.page || 1).orderBy(params.sort)
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setInterestList', res.data)
      commit('setInterestListMeta', res.meta)
    },

    async getInterestDetails({ commit }, id) {
      const { data } = await Api.get(`admin/interests/${id}`)
      commit('setInterestDetails', data.data)
    },

    async createInterest({ commit }, formData) {
      const { data } = await Api.post(`admin/interests`, formData)
      commit('setInterestDetails', data.data)
    },

    async updateInterest({ commit }, formData) {
      const { data } = await Api.put(`admin/interests/${formData.id}`, formData)
      commit('setInterestDetails', data.data)
    },

    async deleteInterest({ commit }, id) {
      await Api.delete(`admin/interests/${id}`)
      commit('clearInterestDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/interests/export/${params.search}`
        : `admin/interests/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
